@use "~theme/typography";

.container {
  padding-top: 52px;
  grid-column: 1 / 10;
}

.icon {
  display: block;
  margin: auto;
}

.header {
  @include typography.body;
  font-weight: var(--semibold-weight);
  text-align: center;
  margin: 12px 0 20px;
}

.description {
  @include typography.caption;
  max-width: 412px;
  text-align: center;
  margin: 0 auto 72px;
}
